import {HStack, Text} from "@chakra-ui/react";
import {ArrowBackIcon} from "@chakra-ui/icons";
import * as React from "react";
import {useNavigate} from "react-router-dom";

export const BackButtonComponent = () => {
    const navigate = useNavigate();
    return <HStack w={"100%"} alignItems={"center"} pt={"16px"} px={"32px"} justifyContent={"space-between"}>
        <HStack alignItems={"center"} p={"16px"} _hover={{
            backgroundColor: "tertiary.200",
            borderRadius: "16px",
        }} cursor={"pointer"} onClick={() => {
            navigate(-1);
        }}>
            <ArrowBackIcon/>
            <Text fontWeight={"bold"}>Indietro</Text>
        </HStack>
    </HStack>
}
